import React, { useState, useEffect } from "react";
import {
  Box,
  Tabs,
  TabList,
  Tab,
  TabPanels,
  TabPanel,
  Accordion,
  AccordionItem,
  AccordionButton,
  AccordionPanel,
  AccordionIcon,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  IconButton,
  Spinner,
  Flex,
  Button,
  Select,
  Text,
  Stack,
  Input,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  Icon,
  ModalBody,
  ModalFooter,
  useToast,
  useDisclosure,
  FormControl,
  FormLabel,
} from "@chakra-ui/react";
import { FaTrash, FaEdit, FaUserTie, FaTags } from "react-icons/fa";
import axios from "axios";
import { BASE_URL } from "../../../Globalapi/Globalapi";

const SubCatForm = () => {
  const [events, setEvents] = useState([]);
  const {
    isOpen: isDeleteModalOpen,
    onOpen: onOpenDeleteModal,
    onClose: onCloseDeleteModal,
  } = useDisclosure();
  const toast = useToast();

  const [categories, setCategories] = useState([]);
  const [filteredCategories, setFilteredCategories] = useState([]);
  const [subCategories, setSubCategories] = useState([]);
  const [selectedEvent, setSelectedEvent] = useState("");
  const [selectedCategory, setSelectedCategory] = useState("");
  const [teachers, setTeachers] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [selectedSubCategory, setSelectedSubCategory] = useState(null);
  const [newSubCategoryName, setNewSubCategoryName] = useState("");
  const [selectedTeacher, setSelectedTeacher] = useState("");
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [rowsPerPage, setRowsPerPage] = useState(10); // Default rows per page
  const [currentPage, setCurrentPage] = useState(1); // Default current page
  const [searchTerm, setSearchTerm] = useState(""); // Search term for filtering
  const schoolId = sessionStorage.getItem("school_id");
  const userId = sessionStorage.getItem("user_id");

  useEffect(() => {
    const fetchEvents = async () => {
      try {
        const response = await axios.get(
          `${BASE_URL}/admin/events/event/list_all_event.php?school_id=${schoolId}`
        );
        if (response.data.success) {
          setEvents(response.data.data.events);
        } else {
          toast({
            title: "Book Issued Successfully",
            description: "The book has been successfully issued.",
            status: "success",
            duration: 5000,
            isClosable: true,
          });
        }
      } catch (error) {
        console.error("Error fetching events:", error);
        toast({
          title: "Error Fetching Events",
          description: "An error occurred while fetching events.",
          status: "error",
          duration: 5000,
          isClosable: true,
        });
      }
    };

    fetchEvents();
  }, [schoolId]);

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const response = await axios.get(
          `${BASE_URL}/admin/events/category/list_category.php?school_id=${schoolId}`
        );
        console.log("all cat@", response);
        if (response.data.success) {
          setCategories(response.data.data);
        } else {
          toast({
            title: "Error",
            description: `Error: ${response.data.message}`,
            status: "error",
            duration: 5000,
            isClosable: true,
          });
        }
      } catch (error) {
        console.error("Error fetching categories:", error);
        toast({
          title: "Error Fetching Categories",
          description: "An error occurred while fetching categories.",
          status: "error",
          duration: 5000,
          isClosable: true,
        });
      }
    };

    fetchCategories();
  }, [schoolId]);

  useEffect(() => {
    const fetchSubCategories = async () => {
      try {
        const response = await axios.get(
          `${BASE_URL}/admin/events/sub_category/list_subcat.php?school_id=${schoolId}`
        );

        console.log("subcateg@@", response);
        if (response.data.success) {
          // Transform the data to a flat array of subcategories with their category_name
          const transformedData = response.data.data.flatMap((event) =>
            event.categories.flatMap((category) =>
              category.sub_categories.map((subCat) => ({
                ...subCat,
                category_name: category.category_name, // Add category_name to each subcategory
              }))
            )
          );
          setSubCategories(transformedData);
        } else {
          setError(response.data.message);
        }
      } catch (err) {
        setError("Failed to fetch data");
      } finally {
        setLoading(false);
      }
    };

    fetchSubCategories();
  }, [schoolId]);

  useEffect(() => {
    const fetchTeachers = async () => {
      try {
        const jwt = sessionStorage.getItem("jwt");
        const school_id = sessionStorage.getItem("school_id"); // If JWT is needed

        const response = await axios.get(
          `${BASE_URL}/admin/staff/staff_list.php?school_id=${school_id}`,
          {
            headers: {
              Authorization: `Bearer ${jwt}`,
            },
          }
        );

        if (response.data.data) {
          setTeachers(response.data.data);
        } else {
          console.error("Error: Invalid teacher data.");
        }
      } catch (error) {
        console.error("Error fetching teachers:", error);
      }
    };

    fetchTeachers();
  }, []);

  const handleEventChange = (event) => {
    setSelectedEvent(event.target.value);
    setFilteredCategories(
      categories.filter((cat) => cat.event_title === event.target.value)
    );
    setSelectedCategory("");
  };

  const handleCategoryChange = (event) => {
    setSelectedCategory(event.target.value);
  };

  const handleRemoveFieldGroup = async (subcatId) => {
    try {
      const response = await axios.delete(
        `${BASE_URL}/admin/events/sub_category/delete_subcat.php`,
        {
          data: {
            school_id: schoolId,
            subcatId,
            pass: userId,
          },
        }
      );

      if (response.data.success) {
        setSubCategories((prev) =>
          prev.filter((subCategory) => subCategory.subcat_id !== subcatId)
        );
        toast({
          title: "Sub-category deleted.",
          description: "Sub-category has been successfully deleted.",
          status: "success",
          duration: 3000,
          isClosable: true,
        });
      } else {
        toast({
          title: "Error deleting sub-category.",
          description: response.data.message,
          status: "error",
          duration: 3000,
          isClosable: true,
        });
      }
    } catch (error) {
      toast({
        title: "Error deleting sub-category.",
        description: error.message,
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    } finally {
      onCloseDeleteModal();
    }
  };

  const handleEditSubCategory = async (subCategoryId) => {
    setIsLoading(true); // Start loading

    try {
      const response = await fetch(
        `${BASE_URL}/admin/events/sub_category/view_subcat.php?subcat_id=${subCategoryId}`
      );
      const data = await response.json();
      console.log("respo", response);

      if (data.success) {
        const subCategory = data.data[0]?.categories[0]?.sub_categories[0]; // Get the first subcategory if it exists
        if (subCategory) {
          setSelectedSubCategory(subCategory);
          setNewSubCategoryName(subCategory.sub_category);
          setSelectedTeacher(subCategory.allocated_teacher_id || ""); // Set the teacher if available
        }
      } else {
        console.error("Failed to load subcategory data:", data.message);
      }
    } catch (error) {
      console.error("Error fetching subcategory:", error);
    } finally {
      setIsLoading(false); // Stop loading
    }

    onOpen(); // Open the modal
  };

  const handleSaveSubCategory = async () => {
    try {
      const payload = {
        school_id: schoolId,
        subcat_id: selectedSubCategory?.subcat_id,
        subcategory: newSubCategoryName,
        allocated_teacher: selectedTeacher,
        user_id: userId,
      };

      const response = await axios.put(
        `${BASE_URL}/admin/events/sub_category/edit_subcat.php`,
        payload
      );
      console.log("edited data--", response);
      if (response.data.success) {
        // const updatedSubCatData = response.data.data;
        // const newTeacherName = updatedSubCatData.allocated_teacher_name; // പുതിയ പേര്

        // setSubCategories((prev) =>
        //   prev.map((subCategory) =>
        //     subCategory.subcat_id === selectedSubCategory.subcat_id
        //       ? {
        //           ...subCategory,
        //           sub_category: newSubCategoryName, // സ്ഥിരമായ പരിഹാരം: API തരുന്ന കൃത്യമായ പേര് ഉപയോഗിച്ച് സ്റ്റേറ്റ് അപ്ഡേറ്റ് ചെയ്യുന്നു.
        //           allocated_teacher: newTeacherName,
        //           // ആവശ്യമുണ്ടെങ്കിൽ teacher_id-യും അപ്ഡേറ്റ് ചെയ്യാം
        //           // allocated_teacher_id: updatedSubCatData.allocated_teacher_id,
        //         }
        //       : subCategory
        //   )
        // );

        setSubCategories((prev) =>
          prev.map((subCategory) =>
            subCategory.subcat_id === selectedSubCategory.subcat_id
              ? {
                  ...subCategory,
                  sub_category: newSubCategoryName,
                  allocated_teacher: selectedTeacher,
                }
              : subCategory
          )
        );
        toast({
          title: "Sub-category edited.",
          description: "Sub-category updated successfully!",
          status: "success",
          duration: 3000,
          isClosable: true,
        });
        onClose();
      } else {
        toast({
          title: "Failed to update sub-category.",
          description: response.data.message,
          status: "error",
          duration: 3000,
          isClosable: true,
        });
      }
    } catch (error) {
      console.error("Error updating sub-category:", error);
      toast({
        title: "Error updating sub-category.",
        description: error.message,
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    }
  };
  // Pagination logic
  const totalPages = Math.ceil(filteredCategories.length / rowsPerPage);
  const indexOfLastRow = currentPage * rowsPerPage;
  const indexOfFirstRow = indexOfLastRow - rowsPerPage;
  const paginatedCategories = filteredCategories.slice(
    indexOfFirstRow,
    indexOfLastRow
  );

  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

  const handleFilterChange = (e) => {
    setSearchTerm(e.target.value);
  };

  return (
    <Box overflowX="auto" p={4}>
      {loading && (
        <Flex justify="center" align="center" height="200px">
          <Spinner size="xl" />
        </Flex>
      )}
      {error && (
        <Flex justify="center" align="center" height="200px" color="red.500">
          {error}
        </Flex>
      )}
      {!loading && !error && (
        <>
          {/* Search and Rows per Page Section */}
          <Flex
            direction={{ base: "column", md: "row" }}
            justify="space-between"
            align="center"
            p={4}
            className="sb"
            style={{
              gap: "20px", // This adds the gap between the rows in mobile view
            }}
          >
            <Stack direction="row" spacing={4}>
              <Flex align="center">
                <Text mr={2}>Rows Per Page</Text>
                <Select
                  width={{ base: "140px", md: "100px" }}
                  value={rowsPerPage}
                  onChange={(e) => setRowsPerPage(Number(e.target.value))}
                  borderColor="#E9EDF4"
                >
                  <option value={10}>10</option>
                  <option value={20}>20</option>
                  <option value={50}>50</option>
                </Select>
              </Flex>
            </Stack>

            {/* New Filters Section on the Right Side */}
            <Flex
              align="center"
              direction={{ base: "column", md: "row" }}
              spacing={4}
              style={{
                gap: "10px", // This will apply space between rows in mobile view
              }}
            >
              {/* Event Selection */}
              <FormControl style={{ flex: 1 }}>
                <Select
                  placeholder="Select event"
                  width={{ base: "100%", md: "170px" }}
                  value={selectedEvent}
                  onChange={handleEventChange}
                >
                  {events.map((event) => (
                    <option key={event.event_id} value={event.event_title}>
                      {event.event_title}
                    </option>
                  ))}
                </Select>
              </FormControl>

              {/* Category Selection */}
              {filteredCategories.length > 0 && (
                <FormControl style={{ flex: 1 }}>
                  <Select
                    placeholder="Select category"
                    value={selectedCategory}
                    onChange={handleCategoryChange}
                  >
                    {filteredCategories.map((category) => (
                      <option
                        key={category.category_id}
                        value={category.category_name}
                      >
                        {category.category}
                      </option>
                    ))}
                  </Select>
                </FormControl>
              )}
            </Flex>
          </Flex>

          <Box overflowX="auto" maxWidth="100%">
            {/* Table Section */}
            {selectedCategory && (
              <Table
                sx={{
                  "tbody tr:nth-of-type(even)": { backgroundColor: "#f2f4f8" },
                }}
                width="100%"
              >
                <Thead>
                  <Tr>
                    <Th>Subcategory</Th>
                    <Th>Allocated Teacher</Th>
                    <Th>Actions</Th>
                  </Tr>
                </Thead>
                <Tbody>
                  {subCategories
                    .filter(
                      (subCat) => subCat.category_name === selectedCategory
                    )
                    .map((subCategory) => (
                      <Tr key={subCategory.subcat_id}>
                        <Td>{subCategory.sub_category}</Td>
                        <Td>{subCategory.allocated_teacher}</Td>
                        <Td>
                          <Button
                            leftIcon={<FaEdit />}
                            colorScheme="blue"
                            size="sm"
                            mr={2}
                            onClick={() =>
                              handleEditSubCategory(subCategory.subcat_id)
                            }
                          >
                            Edit
                          </Button>
                          <Button
                            leftIcon={<FaTrash />}
                            colorScheme="red"
                            size="sm"
                            onClick={() =>
                              handleRemoveFieldGroup(subCategory.subcat_id)
                            }
                          >
                            Delete
                          </Button>
                        </Td>
                      </Tr>
                    ))}
                </Tbody>
              </Table>
            )}
          </Box>
          {/* Pagination Controls */}
          <Flex justify="end" borderTopWidth="1px" p={3} className="sb2">
            <Button
              onClick={() => handlePageChange(currentPage - 1)}
              isDisabled={currentPage === 1}
            >
              Prev
            </Button>
            <Stack direction="row" mx={2}>
              {currentPage > 1 && (
                <>
                  <Button onClick={() => handlePageChange(1)}>1</Button>
                  {currentPage > 2 && <Text>...</Text>}
                </>
              )}
              <Button backgroundColor="teal" color="white">
                {currentPage}
              </Button>
              {currentPage < totalPages - 1 && (
                <>
                  <Text>...</Text>
                  <Button onClick={() => handlePageChange(totalPages)}>
                    {totalPages}
                  </Button>
                </>
              )}
            </Stack>
            <Button
              onClick={() => handlePageChange(currentPage + 1)}
              isDisabled={currentPage === totalPages}
            >
              Next
            </Button>
          </Flex>
        </>
      )}

      {/* Edit Modal */}
      <Modal
        isOpen={isOpen}
        onClose={onClose}
        size="lg"
        motionPreset="slideInBottom"
      >
        <ModalOverlay bg="blackAlpha.300" backdropFilter="blur(10px)" />
        <ModalContent
          borderRadius="lg"
          boxShadow="xl"
          bg="linear-gradient(135deg, #e0f7f7, #f0ffff)"
          color="gray.700"
          p={6}
          maxW="700px"
          maxH="550px"
          overflowY="auto"
        >
          <ModalHeader
            fontSize="xl"
            fontWeight="bold"
            textAlign="center"
            color="teal.600"
          >
            {" "}
            <Icon as={FaEdit} boxSize={5} mr={2} />
            {selectedSubCategory ? "Edit Sub-Category" : "View Sub-Category"}
          </ModalHeader>
          <ModalCloseButton />
          <ModalBody
            overflowY="auto"
            px={4}
            css={{
              "&::-webkit-scrollbar": {
                width: "6px",
              },
              "&::-webkit-scrollbar-track": {
                background: "rgba(255, 255, 255, 0.2)",
                borderRadius: "10px",
                backdropFilter: "blur(8px)",
              },
              "&::-webkit-scrollbar-thumb": {
                background: "rgba(173, 216, 230, 0.6)",
                borderRadius: "10px",
                backdropFilter: "blur(8px)",
              },
              "&::-webkit-scrollbar-thumb:hover": {
                background: "rgba(173, 216, 230, 0.9)",
              },
            }}
          >
            {selectedSubCategory && (
              <>
                <FormControl mb={4}>
                  <FormLabel>
                    <Icon as={FaTags} mr={1} color="teal.500" />
                    Sub-Category Name
                  </FormLabel>
                  <Input
                    bg="white"
                    _hover={{ borderColor: "teal.300" }}
                    value={newSubCategoryName}
                    onChange={(e) => setNewSubCategoryName(e.target.value)}
                    placeholder="Enter sub-category name"
                  />
                </FormControl>
                <FormControl mb={4}>
                  <FormLabel>
                    <Icon as={FaUserTie} mr={1} color="teal.500" />
                    Allocated Teacher
                  </FormLabel>
                  <Select
                    bg="white"
                    _hover={{ borderColor: "teal.300" }}
                    placeholder="Select teacher"
                    value={selectedTeacher}
                    onChange={(e) => setSelectedTeacher(e.target.value)}
                  >
                    {teachers.map((teacher) => (
                      <option key={teacher.id} value={teacher.id}>
                        {teacher.name}
                      </option>
                    ))}
                  </Select>
                </FormControl>
              </>
            )}
          </ModalBody>
          <ModalFooter>
            <Button
              bgGradient="linear(to-r, teal.400, teal.600)"
              color="white"
              _hover={{ bgGradient: "linear(to-r, teal.500, teal.700)" }}
              mr={3}
              onClick={handleSaveSubCategory}
              isDisabled={!selectedSubCategory}
            >
              Save
            </Button>
            {/* <Button variant="ghost" onClick={onClose}>
              Close
            </Button> */}
          </ModalFooter>
        </ModalContent>
      </Modal>

      <Modal isOpen={isDeleteModalOpen} onClose={onCloseDeleteModal}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Delete Sub-Category</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <Text>Are you sure you want to delete this sub-category?</Text>
          </ModalBody>
          <ModalFooter>
            <Button
              colorScheme="red"
              onClick={() =>
                handleRemoveFieldGroup(selectedSubCategory?.subcat_id)
              }
            >
              Delete
            </Button>
            <Button onClick={onCloseDeleteModal}>Cancel</Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </Box>
  );
};

export default SubCatForm;
